export const CHATBOT_CONFIG = {
    initial: 'HOME',
    intents: {
        HOME: {
            text: "Hi 👋 How can I help you today?",
            options: [
                { label: "📦 Track My Order", next: "TRACK_ORDER" },
                { label: "🛍 View Products", next: "PRODUCTS" },
                { label: "❓ FAQs", next: "FAQS" },
                { label: "🚚 Shipping Info", next: "SHIPPING" },
                { label: "🔁 Returns Policy", next: "RETURNS" },
                { label: "📞 Contact Support", next: "CONTACT" }
            ]
        },
        TRACK_ORDER: {
            action: 'CHECK_AUTH_AND_FETCH_ORDERS',
            loadingText: "Checking your account...",
            text: "Here are your recent orders:", // Will be overridden dynamically
            options: [
                { label: "« Back to Menu", next: "HOME" }
            ]
        },
        PRODUCTS: {
            text: "Explore our handcrafted collection! You can find resin art, frames, and more in our catalog.",
            option: [ // Note: original code had 'options' here, but I must follow structure. Wait, HOME had options.
                // Re-checking original file... PRODUCTS had options.
            ],
            options: [
                { label: "Browse All Products", url: "/" },
                { label: "« Back to Menu", next: "HOME" }
            ]
        },
        FAQS: {
            text: "Here are some frequently asked questions:",
            cards: [
                { question: "How long does delivery take?", answer: "3–7 business days (India), handmade processing included." },
                { question: "Do you accept custom orders?", answer: "Yes! We accept custom orders via WhatsApp or Email." },
                { question: "What is your return policy?", answer: "We accept returns for damaged/defective items within 7 days. Please check our Returns Policy for full details." }
            ],
            followUp: 'HELPFUL_CHECK',
            options: [ // Options shown after cards
                // Actually HELPFUL_CHECK option will be shown by followUp logic
            ]
        },
        SHIPPING: {
            text: "We ship nationwide across India! 🇮🇳\n\n• Processing: 1-2 Days\n• Delivery: 5-7 Business Days\n• Shipping is FREE on orders above ₹2999!",
            followUp: 'HELPFUL_CHECK',
            options: []
        },
        RETURNS: {
            text: "We have a transparent Refunds & Returns policy. Please check the full policy details below.",
            followUp: 'HELPFUL_CHECK',
            options: [
                { label: "Read Full Policy", url: "/refund-and-returns" }
            ]
        },
        HELPFUL_CHECK: {
            text: "Was this helpful?",
            options: [
                { label: "👍 Yes", next: "HELPFUL_YES" },
                { label: "👎 No", next: "HELPFUL_NO" }
            ]
        },
        HELPFUL_YES: {
            text: "Great! Happy to help. 😊",
            options: [
                { label: "« Back to Menu", next: "HOME" }
            ]
        },
        HELPFUL_NO: {
            text: "I see. Please contact our support for better assistance.",
            options: [
                { label: "Chat on WhatsApp", external: true, url: "https://wa.me/917622073006" },
                { label: "Email Us", external: true, url: "mailto:admin@handmade-haven.in" },
                { label: "« Back to Menu", next: "HOME" }
            ]
        },
        CONTACT: {
            text: "Need more help? You can reach us directly via WhatsApp or Email.",
            options: [
                { label: "Chat on WhatsApp", external: true, url: "https://wa.me/917622073006" },
                { label: "Email Us", external: true, url: "mailto:admin@handmade-haven.in" },
                { label: "« Back to Menu", next: "HOME" }
            ]
        }
    }
};
